import { render, staticRenderFns } from "./FollowBit.vue?vue&type=template&id=7bc3d80b&"
import script from "./FollowBit.vue?vue&type=script&lang=js&"
export * from "./FollowBit.vue?vue&type=script&lang=js&"
import style0 from "./FollowBit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports